import { render, staticRenderFns } from "./filesDialog.vue?vue&type=template&id=8db6c612&"
import script from "./filesDialog.vue?vue&type=script&lang=js&"
export * from "./filesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports